import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TransferListEntryDto, TransferListEntryOrigin } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { SimpleTableHeader, SimpleTableComponent } from '../../simple-table/simple-table.component';
import { TransferListService } from '../../../services/organisation-management/transfer-list.service';
import { TransferListEntryPopupComponent } from '../transfer-list-entry-popup/transfer-list-entry-popup.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'importer-transfer-list',
  templateUrl: './transfer_list.component.html',
  styleUrls: ['./transfer_list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2ButtonComponent, SimpleTableComponent, AsyncPipe, DatePipe]
})
export class TransferListComponent {
  transferListService = inject(TransferListService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly matDialog = inject(MatDialog);

  public queryParameters$: Observable<Params> = this.route.queryParamMap;
  public updaterIntervalInMs = null;
  public selectedTableHeaders: SimpleTableHeader[] = [
    {
      title: 'Edit',
      width: '50px'
    },
    {
      title: 'Delete',
      width: '50px'
    },
    {
      title: 'Gid',
      key: 'Gid',
      filterType: 'input'
    },
    {
      title: 'Source Org Code',
      key: 'SourceOrgCode',
      filterType: 'input'
    },
    {
      title: 'Target Org Code',
      key: 'TargetOrgCode',
      filterType: 'input'
    },
    {
      title: 'Origin',
      key: 'Origin',
      filterType: 'dropdown',
      values: Object.values(TransferListEntryOrigin)
    },
    {
      title: 'Created at',
      key: 'CreatedAt',
      filterType: 'date'
    },
    {
      title: 'Created by Gid',
      key: 'CreatedByGid',
      filterType: 'input'
    },
    {
      title: 'Last modified at',
      key: 'LastModifiedAt',
      filterType: 'date'
    },
    {
      title: 'Last modified by Gid',
      key: 'LastModifiedByGid',
      filterType: 'input'
    }
  ];

  openCreateTransferListEntryPopup(): void {
    this.matDialog.open(TransferListEntryPopupComponent, {
      data: { action: PopupAction.New, item: {} }
    });
  }

  openUpdateTransferListEntryPopup(item: TransferListEntryDto): void {
    this.matDialog.open(TransferListEntryPopupComponent, {
      data: { action: PopupAction.Edit, item }
    });
  }

  openDeleteTransferListEntryPopup(item: TransferListEntryDto): void {
    this.matDialog.open(TransferListEntryPopupComponent, {
      data: {
        action: PopupAction.Delete,
        item
      }
    });
  }
}
